{
  "type": "object",
  "name": "",
  "class": "g gtc-2 gr-5 gap",
  "definitions": [
    {
      "name": "from",
      "type": "date",
      "title": "Von",
      "class": "gr-1 gc-1",
      "required": true,
      "validations": [
        {
          "isValid": false,
          "messages": [
            {
              "type": "error",
              "subject": "Fehler",
              "message": "Dieses Feld ist erforderlich!"
            }
          ],
          "rule": { "name": "not", "rule": { "name": "empty" } }
        }
      ]
    },
    {
      "name": "to",
      "type": "date",
      "title": "Bis",
      "class": "gr-1 gc-2",
      "required": true,
      "validations": [
        {
          "isValid": false,
          "messages": [
            {
              "type": "error",
              "subject": "Fehler",
              "message": "Dieses Feld ist erforderlich!"
            }
          ],
          "rule": { "name": "not", "rule": { "name": "empty" } }
        }
      ]
    },
    {
      "name": "object",
      "type": "fieldOk",
      "title": "Objekt",
      "autoLoad": true,
      "fieldOk": "objekt",
      "format": "{{number}} - {{name}}",
      "resultMapping": {
        "objekt": "number",
        "bezeichnung": "name"
      },
      "class": "gr-2 gc-1-2"
    }
  ]
}
